export enum TipoEtiquetaEnum {
  Produto = 1,
  ClientesFornecedores = 2,
  Volumes = 3,
  Transportadora = 4,
  Separacao = 5,
}
